<template>
  <div class="deptManagementList">
    <el-card>
      <!-- 添加部门 -->
      <el-button type="primary" slot="header" @click="add">{{$t('lang.key_adddeptName')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- 多选框 -->
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px" ></el-table-column>
        <!-- 部门名称 -->
        <el-table-column prop="name" :label="$t('lang.key_deptName')" ></el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <!-- 修改部门 -->
            <el-button @click="edit(scope.row.id, scope.row.name)">{{$t('lang.btn_modify')}}</el-button>
            <!-- 删除部门 -->
            <el-button class="orange" @click="deletetable(scope.row.id)" >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"/>
    </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="changeTitle"
      @closed="handleDialogClosed">
        <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
          <!-- 弹框的部门名称 -->
          <el-form-item :label="$t('lang.key_deptName')" prop="name">
            <el-input v-model="form.name" :placeholder="$t('lang.lab_inputDeptName')"></el-input>
          </el-form-item>
        </el-form>
      <div slot="footer">
        <!-- 清空弹框 -->
        <el-button @click="rest('form')" class="cancel">{{$t('lang.btn_rest')}}</el-button>
        <!-- 编辑/添加部门保存 -->
        <el-button type="primary" :disabled="isDisabled"  @click="editLabel('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:deptManagementList
 *@Description:部门管理添加/编辑
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-30
 */
export default {
  data() {
    return {
      saveData: '', // 存储json字符串
      tableData: [], // 存储部门的数组
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      isDisabled: false,
      multipleSelection: [], // 多选框
      pageSize: 10, // 每页显示数
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      changeTitle: '', // 变化的弹框title
      show: false, // 弹框默认隐藏
      groupId: '',
      editId: '', // 编辑的id
      form: {
        name: ''
      },
      rules: {
        name: [
          { required: true, message: this.$i18n.t('lang.lab_inputDeptName'), trigger: 'blur' },
          { max: 10, message: this.$i18n.t('lang.lab_inputDeptNameTen'), trigger: 'blur' }
        ]
      },
    }
  },
  created() {
    this.groupId = this.$route.query.id
    this.getTablelist()
    
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 部门列表
    getTablelist() {
      let loading = this.$loading()
      this.$get(`/dept/?pageNo=${this.pageNo}&pageSize=${this.pageSize}&groupId=${this.groupId}`).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加部门
    add() {
      this.form.name = ''
      this.editId = ''
      this.changeTitle = this.$i18n.t('lang.key_adddeptName')
      this.show = true
    },
    // 编辑部门
    edit(id, name) {
      this.form.name = name
      this.editId = id
      this.changeTitle = this.$i18n.t('lang.key_editdeptName')
      this.saveData = JSON.stringify(this.form)
      this.show = true
    },
    // 编辑部门弹框
    editLabel(form) {
      if (this.editId === '') {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let params = {
              name: this.form.name,
              groupId: this.groupId
            }
            let loading = this.$loading()
            this.$post(`/dept/`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      } else {
        this.$refs[form].validate((valid) => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            name: this.form.name,
            groupId: this.groupId
          }
          this.$patch(`/dept/${this.editId}`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
      }
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.name = ''
      this.$refs.form.clearValidate()
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 弹框点击取消按钮
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.name = ''
    },
    // 删除部门
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
          // 添加del的url
        this.$delete(`/dept/` + id).then(res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message({
              type: 'success',
              message: this.$i18n.t('lang.lab_del_success')
            })
            this.commit()
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        })
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
  }
}
</script>

<style lang="scss">

</style>